import { render, staticRenderFns } from "./PodrucjeTemeEdit.vue?vue&type=template&id=f398bd84&scoped=true&"
import script from "./PodrucjeTemeEdit.vue?vue&type=script&lang=js&"
export * from "./PodrucjeTemeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f398bd84",
  null
  
)

export default component.exports